import React, {useContext} from 'react';

import FormikInput from "components/input/new/FormikInput";
import {ShippingMethodFormContext} from "../../../context/ShippingMethodFormContext";
import {ShippingMethodsDiscr} from "../../../../../../../utils/ShippingMethods";

function ContractNumberField(props) {
    const {discr} = useContext(ShippingMethodFormContext);

    return (
        <FormikInput
            name={'contractNumber'}
            label={'shippingMethods.form.field.contractNumber.label'}
            placeholder={'shippingMethods.form.field.contractNumber.placeholder'}
            required={ShippingMethodsDiscr.DPD !== discr}
        />
    );
}

export default ContractNumberField;
